import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './FilterDropdown.module.scss';

const FilterDropdown = ({ title, items, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const dropdownRef = useRef(null);

    const handleItemClick = (item) => {
        const alreadySelected = selectedItems.includes(item);
        const updatedSelectedItems = alreadySelected
            ? selectedItems.filter((selectedItem) => selectedItem !== item)
            : [...selectedItems, item];

        setSelectedItems(updatedSelectedItems);
        onChange(item.slug, !alreadySelected);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.addEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className={styles['FilterDropdown']} ref={dropdownRef}>
            <button
                className={classNames(styles['FilterDropdown__Filter'], {
                    [styles['FilterDropdown__Filter--Selected']]:
                        selectedItems.length > 0,
                })}
                onClick={() => setIsOpen(!isOpen)}
                aria-expanded={isOpen}
            >
                <span className={styles['FilterDropdown__Title']}>
                    {selectedItems.length > 0
                        ? selectedItems.map((item) => item.label).join(', ')
                        : title}
                </span>
            </button>
            {isOpen && (
                <ul
                    className={styles['FilterDropdown__List']}
                    data-choice={true}
                    aria-hidden={!isOpen}
                >
                    {items.map((item) => (
                        <li
                            key={item.slug}
                            className={styles['FilterDropdown__Item']}
                        >
                            <button
                                className={styles['FilterDropdown__ItemButton']}
                                onClick={() => handleItemClick(item)}
                            >
                                <span
                                    className={classNames(
                                        styles['FilterDropdown__Checkbox'],
                                        {
                                            [styles[
                                                'FilterDropdown__Checkbox--Active'
                                            ]]: selectedItems.includes(item),
                                        }
                                    )}
                                    data-choice={true}
                                    aria-hidden={true}
                                />
                                {item.label}
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

FilterDropdown.propTypes = {
    title: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            slug: PropTypes.string,
        })
    ),
    onChange: PropTypes.func,
};

FilterDropdown.defaultProps = {
    title: '',
    items: [],
    onChange: () => {},
};

export default FilterDropdown;
